import environment from "../environments/environment";
import { clearAuthSessionStorage } from "./authSession";

let refreshPromise = null;

export const isAccessTokenExpiredMessage = (message = "") => message === "jwt expired";

export const isSessionInvalidMessage = (message = "") => message === "Session expired or revoked";

export const redirectToLogin = () => {
  if (typeof window !== "undefined" && window.location.pathname !== "/login") {
    window.location.replace("/login");
  }
};

export const clearAuthAndRedirect = () => {
  clearAuthSessionStorage();
  redirectToLogin();
};

export const refreshAuthSession = async () => {
  if (refreshPromise) return refreshPromise;

  refreshPromise = (async () => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const res = await fetch(`${environment.apiUrl}/auth/refresh`, {
        method: "POST",
        signal: controller.signal,
        credentials: "include",
        cache: "no-store",
        headers: {
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
        },
      });

      const body = await res.json().catch(() => null);
      // Only an explicit auth rejection invalidates the existing session.
      if (res.status === 401) return false;
      if (!res.ok || !body || body.success !== true) {
        throw new Error("Session refresh temporarily unavailable");
      }
      return true;
    } finally {
      clearTimeout(timeout);
      refreshPromise = null;
    }
  })();

  return refreshPromise;
};
